<template>
    <v-main :style="{background: 'white'}">
      <v-container class="containerText">
        <v-layout text-center>
          <v-flex>
            <div class="mt-5 pa-1 text-left">
              <h2>{{$t('imprint')}}</h2>
              <div style="position:relative;height:100vh;">
                <HLLegalFrame kind="imprint"/>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

</template>

<script>
import HLLegalFrame from '@/components/ui/HLLegalFrame.vue'

export default {
  components: {
    HLLegalFrame
  }
}
</script>

<style scoped>
a{
  overflow-wrap: break-word;
}
.containerText{
  max-width: 70%;
}
.subTitle {
    font-weight:bold;
}
</style>
